import { TokenInfoWithPrice } from "@/api";

export interface ResetScrollHandle {
  resetScroll: () => void;
}

export interface TabListBaseProps {
  onSelectToken: (token: TokenInfoWithPrice) => void;
  scrollRef: React.RefObject<ResetScrollHandle>;
}

export function filterRankSortTokens(
  search: string,
  tokens: TokenInfoWithPrice[],
): TokenInfoWithPrice[] {
  const filterLwr = search.trim().toLowerCase();
  return tokens
    .filter((token) => {
      switch (true) {
        case token.address === search:
          return true;
        case token.symbol?.toLowerCase().includes(filterLwr):
          return true;
        case token.name?.toLowerCase().includes(filterLwr):
          return true;
        default:
          return false;
      }
    })
    .map((token) => {
      const rank = (() => {
        switch (true) {
          case token.address === search:
            return 1;
          case token.symbol?.toLowerCase() === filterLwr:
            return 2;
          case token.name?.toLowerCase() === filterLwr:
            return 3;
          case token.symbol?.toLowerCase().includes(filterLwr):
            return 4;
          case token.name?.toLowerCase().includes(filterLwr):
            return 5;
          default:
            return 6;
        }
      })();

      return { rank, ...token };
    })
    .sort((a, b) => a.rank - b.rank);
}
